// ABOUTME: The round add button with a menu — one component for every section
// ABOUTME: of the mobile day; sections differ only by its colour and its items

import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { PlusStrokeIcon } from "../icons"
import { CDropdown } from "./CDropdown"

/** Sections wear their own colour; everything else about the button is shared. */
export type FloatingAddTone = "blue" | "orange"

const toneClass: Record<FloatingAddTone, string> = {
  blue: "bg-blue-400",
  orange: "bg-orange-400",
}

interface CFloatingAddProps {
  tone?: FloatingAddTone
  /** Menu contents — CDropdown.Item children. */
  children: ReactNode
  /** Where the button sits; the button itself looks the same everywhere. */
  className?: string
}

export const CFloatingAdd = ({ tone = "blue", children, className = "" }: CFloatingAddProps) => {
  const { t } = useTranslation()

  return (
    <CDropdown
      // Upwards: the button sits at the bottom of the screen, so a menu
      // dropping down would open off-screen.
      placement="top-end"
      arrowIcon={false}
      contentClassName="min-w-[200px]"
      className={className}
      label={
        <span
          title={t("common.add")}
          // rounded-[50%], not rounded-full: Tailwind v4 compiles the latter to
          // `calc(infinity * 1px)`, which older WebKit drops — and a dropped
          // radius leaves a square.
          className={`flex size-14 items-center justify-center rounded-[50%] text-white ${toneClass[tone]}`}
        >
          <PlusStrokeIcon
            size={26}
            color="currentColor"
          />
        </span>
      }
    >
      {children}
    </CDropdown>
  )
}
